import { DetailTabType } from 'store/analytics/ui/analyticsUiTypes';
import { InspectionViewRequest, TxiViewRequest } from 'types/rest/analyticsTypes';

/**
 * Nested actions. Make sure all those actions are forwarded to the child reducer from
 * parent reducer.
 */
export const SET_INSPECTION_VIEW_ACTIVE_PAGE = 'SET_INSPECTION_VIEW_ACTIVE_PAGE';
export const SET_INSPECTION_VIEW_PAGE_SIZE = 'SET_INSPECTION_VIEW_PAGE_SIZE';
export const SET_SEARCH_KEYWORD = 'SET_SEARCH_KEYWORD';
export const SELECT_INSPECTION_VIEW_REQUEST = 'SELECT_INSPECTION_VIEW_REQUEST';
export const SELECT_REQUEST_DETAIL_TAB = 'SELECT_REQUEST_DETAIL_TAB';

export type ChangeActivePage = {
  type: typeof SET_INSPECTION_VIEW_ACTIVE_PAGE;
  payload: number;
};

export type ChangePageSize = {
  type: typeof SET_INSPECTION_VIEW_PAGE_SIZE;
  payload: number;
};

export type SelectInspectionViewRequest = {
  type: typeof SELECT_INSPECTION_VIEW_REQUEST;
  payload: InspectionViewRequest | TxiViewRequest | null;
};

export type SelectRequestDetailTab = {
  type: typeof SELECT_REQUEST_DETAIL_TAB;
  payload: DetailTabType;
};

export type SetSearchKeyword = {
  type: typeof SET_SEARCH_KEYWORD;
  payload: string;
};

export type InspectionViewActionTypes =
  | ChangeActivePage
  | ChangePageSize
  | SelectInspectionViewRequest
  | SetSearchKeyword
  | SelectRequestDetailTab;
